import React from 'react';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import Banner from '../../styled/components/single-column-banner';
const ThankYouBanner = () => (React.createElement(Banner, { className: 'flex-dir-col pad pad-top-lg pad-bottom-lg' },
    React.createElement(SRow, { className: 'align-items-center' },
        React.createElement(SCol, { span: '12', center: '', className: 'pad-bottom-none' },
            React.createElement("p", { className: 'fourth-line text-uppercase' }, "Avalara Professional Services"))),
    React.createElement(SRow, { className: 'align-items-center' },
        React.createElement(SCol, { span: '12', center: '', className: 'pad-bottom-none' },
            React.createElement("p", { className: 'single-line', "data-ref": 'risk-assessment.thankyou-header' }, "Thanks for buying a Sales Tax Risk Assessment")))));
export default ThankYouBanner;
